// Lib
import React from 'react';
import { UseSheetReturnType } from '../../../mobile/structural/sheet/hooks/useSheet';
import SheetContainer, {
    CloseButton,
    Content,
    Header,
    Heading,
    Overlay,
    Sheet,
} from '../../../mobile/structural/sheet';
import Thread from '../Thread';
import { MNComment } from '../../../../common/comments/commentTypes';
import { ImMNElement } from '../../../../common/elements/elementModelTypes';
import { pluralise } from '../../../../common/utils/stringUtil';

// Styles
import './CommentThreadSheet.scss';

interface CommentThreadSheetContentProps {
    element: ImMNElement;
    currentUserId: string;
    commentList: MNComment[];
}

const CommentThreadSheetContents: React.FC<CommentThreadSheetContentProps> = (props) => {
    const { element, currentUserId, commentList } = props;

    return <Thread element={element} currentUserId={currentUserId} commentList={commentList} />;
};

interface CommentThreadSheetProps extends CommentThreadSheetContentProps {
    closePopup: () => void;
    sheetProps: UseSheetReturnType;
}

const CommentThreadSheet: React.FC<CommentThreadSheetProps> = (props) => {
    const { sheetProps, closePopup, element, currentUserId, commentList } = props;

    return (
        <SheetContainer className="CommentThreadSheet" {...sheetProps} defaultSnapPoint={1} snapPoints={[1]}>
            <Overlay />
            <Sheet>
                <Header>
                    <Heading>
                        {commentList.length}&nbsp;
                        {pluralise('comment', commentList.length)}
                    </Heading>
                    <CloseButton onClick={closePopup} />
                </Header>
                <Content>
                    <CommentThreadSheetContents
                        element={element}
                        currentUserId={currentUserId}
                        commentList={commentList}
                    />
                </Content>
            </Sheet>
        </SheetContainer>
    );
};

export default CommentThreadSheet;
